module.exports = __webpack_public_path__ + "static/img/ddky_logo.566cc4fa.png";